import { makeStyles } from "tss-react/mui";

import { Theme, Typography } from "@mui/material";

const useStyles = makeStyles<{ progress: number; color?: string }>()((theme: Theme, { progress, color }) => ({
    container: {
        display: "flex",
        width: "100%",
        alignItems: "center",
    },
    outlineBox: {
        height: "10px",
        backgroundColor: theme.palette.emteria.border.primary,
        borderRadius: 50,
        display: "flex",
        width: "100%",
        overflow: "hidden",
    },
    progress: {
        width: `${progress}%`,
        backgroundColor: color,
        borderRadius: 50,
        height: "100%",
        transition: "width 0.3s ease",
    },
    progressPercentage: {
        paddingLeft: theme.spacing(1),
    },
}));

const getFormattedProgress = (progressNumber: number) => {
    if (progressNumber === 100) {
        return "100%";
    } else if (progressNumber > 0 && progressNumber < 1) {
        return "1%";
    } else {
        return `${Math.floor(progressNumber)}%`;
    }
};

interface Props {
    progress: number;
    color?: string;
    hideLabel?: boolean;
    className?: string;
}

export const ProgressBar = ({ progress, color, hideLabel, className }: Props) => {
    const { classes, cx } = useStyles({ progress: Math.round(progress), color });

    return (
        <div className={cx(classes.container, className)} data-testid="progress-bar">
            <div className={classes.outlineBox}>
                <div className={classes.progress} />
            </div>
            <Typography className={classes.progressPercentage}>
                {hideLabel ? "\u00A0" : getFormattedProgress(progress)}
            </Typography>
        </div>
    );
};
